import { createFileRoute } from "@tanstack/react-router";

import { ApiKeysPage } from "~/pages/settings/api-keys/api-keys.page";

export const Route = createFileRoute("/_app/settings/_organization/api-keys")({
  component: ApiKeysPage,
});
